const component = "simple-site-sections-tree";

export const simpleSiteSectionsTree = {
  component,
  loader: `${component}/loader`,
  noResultText: `${component}/no-result-text`,
  siteSectionTree: `${component}/site-section-tree`,
  siteIcon: `${component}/site-icon`,
  sectionIcon: `${component}/section-icon`,
  nodeLabel: `${component}/node-label`,
  nodeIndeterminateCheckbox: `${component}/node-indeterminate-checkbox`,
};
